export function normalizeRemitValue (value) {
  return (value || '').trim().toLowerCase()
}

export function getRemitComparableValues (source) {
  if (!source) {
    return {
      name: '',
      phone: '',
      location: '',
      department: '',
      address: ''
    }
  }

  return {
    name: source.name || '',
    phone: source.phone !== undefined
      ? (source.phone || '')
      : (source.phones && source.phones[0] ? source.phones[0] : ''),
    location: source.location || '',
    department: source.department || '',
    address: source.address || ''
  }
}

export function remitFieldDiffers (entry, reference, field) {
  if (!entry || !reference) return false

  const current = getRemitComparableValues(reference)

  if (field === 'name') {
    return normalizeRemitValue(entry.name) !== normalizeRemitValue(current.name)
  }

  if (field === 'phone') {
    return normalizeRemitValue(entry.phone) !== normalizeRemitValue(current.phone)
  }

  if (field === 'location') {
    return normalizeRemitValue(entry.location) !== normalizeRemitValue(current.location) ||
      normalizeRemitValue(entry.department) !== normalizeRemitValue(current.department)
  }

  if (field === 'address') {
    return normalizeRemitValue(entry.address) !== normalizeRemitValue(current.address)
  }

  return false
}

export function remitFieldDiffersFromOrder (entry, order, field) {
  return remitFieldDiffers(entry, order, field)
}

const REMIT_COMPARE_FIELDS = ['name', 'phone', 'location', 'address']

export function remitEntryDiffersFromReference (entry, reference) {
  return REMIT_COMPARE_FIELDS.some(field => remitFieldDiffers(entry, reference, field))
}

export function remitEntryDiffersFromOrder (entry, order) {
  return remitEntryDiffersFromReference(entry, order)
}

export function getRemitReferenceForEntry (order, displayIndex) {
  const remitData = (order && order.remitData) || []
  if (!remitData.length) return order

  const originalIndex = remitData.length - 1 - displayIndex

  if (originalIndex >= remitData.length - 1) {
    return order
  }

  return remitData[originalIndex + 1]
}

export function latestRemitDiffersFromOrder (order) {
  return latestRemitDiffersFromRecord(order)
}

export function latestRemitDiffersFromRecord (record) {
  if (!record || !record.remitData || !record.remitData.length) return false
  const latest = record.remitData[record.remitData.length - 1]
  return remitEntryDiffersFromOrder(latest, record)
}

export function orderHasRemit (order) {
  return recordHasRemit(order)
}

export function recordHasRemit (record) {
  return !!(record &&
    record.remitDataGenerated &&
    record.remitData &&
    record.remitData.length)
}

export function changeHasRemit (change) {
  return recordHasRemit(change)
}

export function getLatestRemitBuyer (order) {
  if (!order || !order.remitData || !order.remitData.length) {
    return {
      name: '',
      phones: [],
      location: '',
      department: '',
      address: ''
    }
  }

  const latest = order.remitData[order.remitData.length - 1]

  return {
    name: latest.name,
    phones: latest.phone ? [latest.phone] : [],
    location: latest.location,
    department: latest.department,
    address: latest.address
  }
}

export function getBuyerRemitFromOrder (order, { remitOnly = false } = {}) {
  if (remitOnly || orderHasRemit(order)) {
    if (order && order.remitData && order.remitData.length) {
      return getLatestRemitBuyer(order)
    }

    if (remitOnly) {
      return getLatestRemitBuyer(null)
    }
  }

  if (!order) {
    return getLatestRemitBuyer(null)
  }

  return {
    name: order.name,
    phones: order.phones || [],
    location: order.location,
    department: order.department,
    address: order.address
  }
}



// WEBPACK FOOTER //
// ./src/helpers/remit.js